import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/remedies"

export const RemediesList = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const AddRemedies = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const EditRemedies = async (values) => {
    return await axiosInstance(options).put(`${path}/edit`, values);
}

export const DeleteRemedies = async (id) => {
    return await axiosInstance(options).delete(`${path}/delete?o_id=${id}`)
}

export const RemediesDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}

export const StatusRemedies = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-status`, values)
}

export const UpdateRemedyStock = async (values) => {
    return await axiosInstance(options).post(`${path}/update-stock`, values)
}